"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewSearchHistory extends new_item_1.default {
    constructor(newSearchHistory) {
        super();
        this.accountId = newSearchHistory.accountId;
        this.metadata = newSearchHistory.metadata;
        this.name = newSearchHistory.name;
        this.itemId = newSearchHistory.itemId;
        this.itemType = newSearchHistory.itemType;
        this.created = newSearchHistory.created;
    }
}
exports.default = NewSearchHistory;
//# sourceMappingURL=new-searchHistory.js.map